// ponytail: hijack creation is event-gated on the server (CreateHijack validates
// parent_event_id against ES, find_dll.go:407). The only client-side decision is
// WHICH id to send when a user both typed one and had clicked a row. Kept as one
// pure function so that rule has a runnable check without mounting the heavy page.
export const resolveHijackParentEventId = (manual: string, selected?: string): string => {
  const trimmed = manual.trim();
  if (trimmed) return trimmed;
  return selected ?? "";
};
